const defaultTimeout = process.env.TEST_STORE_TIMEOUT || 0

function find(test, getter) {
  let state = global.store.getState()
  let element = getter(state)
  if (test) return Object.values(element).find(test)
  else return element
}

function checkInState(test, getter, tm = defaultTimeout) {
  return new Promise((resolve, reject) => {
    let unsubscribe
    let timeout = tm ? setTimeout(() => {
      reject(`timeout ${tm}`)
    }, tm) : null
    function subscribe() {
      let item = find(test, getter)
      if (item) {
        clearTimeout(timeout)
        unsubscribe()
        resolve(item)
      }
    }

    // try once immediately
    let item = find(test, getter)
    if (item) resolve(item)
    else {
      // subscribe to store
      unsubscribe = global.store.subscribe(subscribe)
    }
  })
}

function checkNotInState(test, getElem, tm = defaultTimeout) {
  return new Promise((resolve, reject) => {
    const unsubscribe = global.store.subscribe(subscribe)

    let timeout = tm ? setTimeout(() => {
      reject(`timeout ${tm}`)
    }, tm) : null

    function subscribe() {
      let state = global.store.getState()
      let element = getElem(state)
      if (test) {
        let notIn = !Object.values(element).some(test)
        if (notIn) {
          clearTimeout(timeout)
          unsubscribe()
          resolve()
        }
      } else if (!element) {
        clearTimeout(timeout)
        unsubscribe()
        resolve()
      }
    }
  })
}

module.exports = {
  call({
    action,
    params,
    timeout = 0
  }) {
    return this.request("admin.call", {
      action,
      params
    }, timeout)
  },
  request(event, data, timeout = 0) {
    return new Promise((resolve, reject) => {
      // setup a timeout
      let _timeout = !timeout ? false : setTimeout(() => {
        let err = Error(`${event} timeout`)
        err.data = data
        reject(err)
      }, timeout)

      this.emit(event, data, function (err, res) {
        if (_timeout) clearTimeout(_timeout)
        if (err) reject(err)
        else resolve(res)
      })
    })
  },
  inStore(key, test, timeout) {
    return checkInState(test, state => state[key], timeout)
  },
  inPlatform(key, test, timeout) {
    return checkInState(test, state => state.list[key], timeout)
  },
  inWorkspace(ws, key, test, timeout) {
    return checkInState(test, state => state.workspaces[ws][key], timeout)
  },
  inApplication(ws, app, key, test, timeout) {
    return checkInState(test, state => state.workspaces[ws][app].data[key], timeout)
  },
  notInStore(key, test, timeout) {
    return checkNotInState(test, state => state[key], timeout)
  },
  notInPlatform(key, test, timeout) {
    return checkNotInState(test, state => state.list[key], timeout)
  },
  notInWorkspace(ws, key, test, timeout) {
    return checkNotInState(test, state => state.workspaces[ws][key], timeout)
  },
  notInApplication(ws, app, key, test, timeout) {
    return checkNotInState(test, state => state.workspaces[ws][app].list[key], timeout)
  }
}